export class EnvironmentConfig {
	private static _isDemoEnvironment: boolean | null = null;

	public static isDemoEnvironment(): boolean {
		if (this._isDemoEnvironment === null) {
			this._isDemoEnvironment =
				window.location.hostname.includes("demo") ||
				localStorage.getItem("isDemoMode") === "true";
		}
		return this._isDemoEnvironment;
	}

	public static getLogoUrl(): string {
		return this.isDemoEnvironment()
			? "./img/logo-demo.png"
			: "./img/logo_Alsterfood_Logo.png";
	}

	public static getEnvironmentLabel(): string {
		return this.isDemoEnvironment() ? "DEMO" : "PROD";
	}

	// Force refresh the environment check (useful for testing)
	public static refreshEnvironmentCheck(): void {
		this._isDemoEnvironment = null;
	}
}
